import { handleUserLogOutErro, } from "./utils"
import { setMediaCompLocalStorage, getMediaCompLocalStorage, setMediaCompLocalStorageAuOn } from "../ui/components/MediaComp/MediaCompUtils"

export function processMediaDataWhenData(res) {
  let arrMediaResult = [];
  for (let i = 0; i < res?.data?.ListDados?.length; i += 2) {
    let row = res.data.ListDados[i];
    let rowDep = res.data.ListDados[i + 1];
    let arr = [];
    for (let j = 0; j < row.length; j++) {
      arr.push(row[j] + "|" + rowDep[j]);
    }
    let dateRange = res.data.ListHeader[Math.ceil(i / 2)][0];
    let base = res.data.ListHeader[Math.ceil(i / 2)][1];
    let tipo = res.data.ListHeader[Math.ceil(i / 2)][2];
    arr.unshift(dateRange, base, tipo);
    arrMediaResult.push(arr);
  }
  return arrMediaResult;
}
export function processMediaDataWhenDataHeader(res) {
  let arrMediaResult = [];
  for (let i = 0; i < res?.data?.ListDados?.length; i++) {
    let row = res?.data?.ListDados[i];
    let arr = [];
    for (let item of row) {
      arr.push(item);
    }
    let dateRange = res.data.ListHeader[i][0];
    let base = res.data.ListHeader[i][1];
    let tipo = res.data.ListHeader[i][2];
    arr.unshift(dateRange, base, tipo);
    arrMediaResult.push(arr);
  }
  return arrMediaResult;
}

export function processMediaCompDataWhenDataHeader(res) {
  let arrMediaCompResult = [];
  for (let i = 0; i < res?.data?.ListHeader?.length; i++) {
    let row = res?.data?.ListHeader[i]?.ListDados;
    let arr = [];
    for (let item of row) {
      arr.push(item);
    }
    let dateRange = res.data.ListHeader[i].dataRating.split('T')[0];
    let minutos = res.data.ListHeader[i].minutos;
    let indice = res.data.ListHeader[i].indice;
    let base = res.data.ListHeader[i].baseAverage;
    
    arr.unshift(dateRange, minutos, indice, base);
    arrMediaCompResult.push(arr);
    
  }
  return arrMediaCompResult;
}

export function validResponseMediaDataIsValid(res) {
  return (
    res?.data?.ListDados !== undefined &&
    res?.data?.ListDados?.length > 0 &&
    res?.data?.ListHeader !== undefined &&
    res?.data?.ListHeader?.length > 0
  );
}

export function validResponseMediaCompDataIsValid(res) {
  return (
    Array.isArray(res?.data?.ListHeader) &&
    res.data.ListHeader.length > 0 &&
    res.data.ListHeader.some(header => Array.isArray(header.ListDados) && header.ListDados.length > 0)
  );
}


export function HandleMediaData(res) {
  if (validResponseMediaDataIsValid(res)) {
    let arrMedia = [];
    if (res.data.ListDados.length > res.data.ListHeader.length) {
      try {
        arrMedia = processMediaDataWhenData(res);
      } catch (error) {
        return [];
      }
      return arrMedia;
    } else {
      try {
        arrMedia = processMediaDataWhenDataHeader(res);
      } catch (error) {
        return [];
      }
      return arrMedia;
    }
  }
}

export function HandleMediaCompData(res) {
  if (validResponseMediaCompDataIsValid(res)) {
    let arrMediaComp = [];

    const totalListDados = res.data.ListHeader.reduce((totalLinhas, header) => {
      return totalLinhas + (Array.isArray(header.ListDados) ? header.ListDados.length : 0);
    }, 0);
    const totalListHeader = res.data.ListHeader.length;

    if (totalListDados >= totalListHeader) {
      try {
        arrMediaComp = processMediaCompDataWhenDataHeader(res);
      } catch (error) {
        return [];
      }
      return arrMediaComp;
    }
  }
}



export function AudienceMerge(listDadosRating, setLastMinute, setAudience, setLastThirtyAudiencePie, setLastThirtyAudience, setLastAudience) {
  AudienceLastThirtyMinutePie(listDadosRating[0], setLastThirtyAudiencePie)
  AudienceLastThirtyMinute(listDadosRating, setLastThirtyAudience)
  AudienceLastMinute(listDadosRating[0], setLastAudience)
  setLastMinute(listDadosRating[0][1]);
  setAudience(listDadosRating);
}
export function AudienceLastThirtyMinutePie(response, setLastThirtyAudiencePie) {
  let lastAudience = getAudienceLastThirtyMinutePie(response);
  setLastThirtyAudiencePie(lastAudience);
}
export function AudienceLastThirtyMinutePieMedia(response, setLastThirtyAudiencePie) {
  AudienceLastThirtyMinutePie(response, setLastThirtyAudiencePie);
}
export function getAudienceLastThirtyMinutePie(response) {
  let lastAudience = [];
  if (response && Array.isArray(response)) {
    response?.forEach((value, itemId) => {
      if (itemId > 3) {
        let audienceObj = {
          name: itemId,
          value: (value.split("|")[0] !== '-' && value.split("|")[0] !== '100.0') ? parseFloat(value?.split("|")[0]) : '0',
        }
        lastAudience.push(audienceObj);
      }
    })
  }
  return lastAudience;
}

export function AudienceLastThirtyMinute(response, setLastThirtyAudience) {
  let lastAudience = [], audData = {};
  response.map((row, rowId) => {
    if (rowId > 30) { return; }
    let lastRow = row.map((value, valueId) => {
      audData[valueId] = getAudData(value)
      return audData[valueId];
    }
    )
    lastAudience.push(lastRow);
  })
  let lastAudienceReversed = [...lastAudience];
  lastAudienceReversed.reverse();
  setLastThirtyAudience(lastAudienceReversed);
}

export function getAudData(value) {
  return value !== '-' ? value?.split("|")[0] : '0';
}

export function AudienceLastMinute(res, setLastAudience) {
  let response = res, lastAudience = [], totalMinutes = 0;

  response.map((value, itemId) => {
    if (itemId > 3 && value?.split("|")[0] !== "-")
      totalMinutes += parseFloat(value?.split("|")[0]);
  })

  response.map((value, itemId) => {
    let audienceObj = {
      audRat: value?.split("|")[0],
      audSh: value?.split("|")[1] + '%',
      percent: getAudienceLastMinutePercent(value, totalMinutes),
      percentChart: getAudienceLastMinutePercentChart(value, totalMinutes),
    }
    lastAudience.push(audienceObj);
  })
  setLastAudience(lastAudience);
}

export function getAudienceLastMinutePercent(value, totalMinutes) {
  let percentValue = (parseFloat(value?.split("|")[0]) * 300) / totalMinutes;
  let percent;
  if (percentValue > 5) {
    let innerPercentValue = (parseFloat(value?.split("|")[0]) * 200) / totalMinutes;
    percent = innerPercentValue > 80 ? '80%' : innerPercentValue + '%';
  } else {
    percent = '0.5%';
  }
  return percent;
}

export function getAudienceLastMinutePercentChart(value, totalMinutes) {
  return ((parseFloat(value?.split("|")[0]) * 100) / totalMinutes) > 7 ? ((parseFloat(value?.split("|")[0]) * 210) / totalMinutes) + '%' : 6 + '%';
}

export function AudienceMediaMerge(res, setLastAudience, setLastThirtyAudiencePie, setLastThirtyAudience, setAudienceMedia, setAudienceMediaFirstTable, audienceMediaFirstTable, qtdMinutosMedia) {
  let arrmedia = HandleMediaData(res);
  AudienceLastMinuteMedia(arrmedia[0], setLastAudience);
  let dataHeader = arrmedia.map(arr => arr.slice(0, 3)).slice(0, qtdMinutosMedia);
  let dataMedia = arrmedia.map(arr => arr.slice(3, arr.length)).slice(0, qtdMinutosMedia);
  AudienceLastThirtyMinutePieMedia(arrmedia[0], setLastThirtyAudiencePie);
  AudienceLastThirtyMinuteMedia(dataMedia, setLastThirtyAudience);
  setAudienceMediaFirstTable(dataHeader);
  setAudienceMedia(dataMedia);
}

export function AudienceLastMinuteMedia(res, setLastAudience) {
  let response = res?.slice(), lastAudience = [], totalMinutes = 0;
  response?.forEach((value, itemId) => {
    if (itemId > 3 && value?.split("|")[0] !== "-")
      totalMinutes += parseFloat(value?.split("|")[0]);
  })
  response?.forEach((value, itemId) => {
    let audienceObj = {
      audRat: value?.split("|")[0],
      audSh: value?.split("|")[1] + '%',
      percent: getAudienceLastMinutePercent(value, totalMinutes),
      percentChart: getAudienceLastMinutePercentChart(value, totalMinutes),
    }
    lastAudience.push(audienceObj);
  })
  setLastAudience(lastAudience);
}

export function AudienceLastThirtyMinuteMedia(response, setLastThirtyAudience) {
  let lastAudience = [], audData = {};
  response.map((row, rowId) => {
    if (rowId > 30) { return; }
    let lastRow = row.map((value, valueId) => {
      audData[valueId] = getAudData(value)
      return audData[valueId];
    }
    )
    lastAudience.push(lastRow)
  })
  let lastAudienceReversed = [...lastAudience];
  lastAudienceReversed.reverse();
  setLastThirtyAudience(lastAudienceReversed);
}

export function AudiencePrintMerge(res, setAudiencePrint) {
  if (res.data.CodErro === 0) {
    setAudiencePrint(res.data.ListDadosRating);
  }
  else {
    let arrayERRO = ['ERRO', res.data.CodErro, res.data.MsgErro];
    setAudiencePrint(arrayERRO);
  }
}

export function AudienceMediaCompPrintMerge(res, setAudienceMediaCompPrint) {  
  if (res.data.CodErro === 0) {
    let audienceMediaComp = HandleMediaCompData(res);
    
    if (audienceMediaComp) {
      audienceMediaComp.forEach(array => {
        array.unshift('0');
      });
    }
    setAudienceMediaCompPrint(audienceMediaComp);    
  }
  else {
    let arrayERRO = ['ERRO', res.data.CodErro, res.data.MsgErro];
    setAudienceMediaCompPrint(arrayERRO);
  }
}

export function AudiencePrintMediaMerge(res, setAudiencePrint) {
  if (res.data.CodErro === 0) {
    let audienceMedia = HandleMediaData(res);
    // Move o primeiro elemento para o final
    if (audienceMedia && audienceMedia.length > 1) {
      // const mediaTotalLinha = audienceMedia.shift();
      // audienceMedia.push(mediaTotalLinha);

      //Adiciona o zero no início de cada linha para padronizar com o de minute
      audienceMedia.forEach(array => {
        array.unshift('0');
      });
    }
    setAudiencePrint(audienceMedia);
  }
  else {
    let arrayERRO = ['ERRO', res.data.CodErro, res.data.MsgErro];
    setAudiencePrint(arrayERRO);
  }
}
export function AudienceMinute(listDadosRating, setAudienceFirstTable) {
  let audience = [];
  let audienceMinute = [];
  listDadosRating.map((value, itemId) => {
    audienceMinute = [];
    value.map((row, id) => {
      if (id < 4)
        audienceMinute.push(row);
    })
    audience.push(audienceMinute);
  })
  setAudienceFirstTable(audience);
}

export function AudienceMediaMinute(res, setLastMinute, setAudienceMediaFirstTable, qtdMinutosMedia) {
  setLastMinute(res?.data.ListHeader[0][0]);
  setAudienceMediaFirstTable(res.data.ListHeader.slice(0, qtdMinutosMedia));
}

export function AudienceChartMinute(res, setLastMinute, setAudienceMediaFirstTable) {
  setLastMinute(res?.data.ListHeader[0][0]);
  setAudienceMediaFirstTable(res.data.ListHeader);
}

export function AudienceMediaCompMinute(res, setAudienceMediaCompFirstTable) {
  setAudienceMediaCompFirstTable(res.data.ListHeader);
  let MCLocalStorage = getMediaCompLocalStorage();
  if (MCLocalStorage === null || !res.data.userAutoScroll) {
    let dadosMCLS = res.data.ListHeader[0];
    dadosMCLS.autoUpdate = res.data.userAutoScroll
    setMediaCompLocalStorage(dadosMCLS);
  } else {
    let dadosMCLS = res.data.ListHeader[0];
    let indiceNull = MCLocalStorage.indice == null;
    dadosMCLS.autoUpdate = res.data.userAutoScroll
    setMediaCompLocalStorageAuOn(dadosMCLS, indiceNull);
  }
}

export function doAudienceHandleReturnWithWError401(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi) {
  handleUserLogOutErro(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
}

export function doAudienceHandleReturnWithWError96(dataResponse, setAudience, setAudienceFirstTable, setShowError, setInfoError, setInfoSpan) {
  if (Number(dataResponse.CodErro) === 96) {
    setAudience(null);
    setAudienceFirstTable(null);
    setShowError(true);
    setInfoError(dataResponse.MsgErro);
    setInfoSpan(dataResponse.MsgErro);
  }
} 
